import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_trashcapital/artifacts/r11cbtxk_waste-loan-bros-text-logo.png" 
                alt="Waste Loan Bros"
                className="h-12 md:h-14 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('problem')}
              className={`font-semibold text-sm tracking-wider hover:text-[#00A86B] transition-colors ${
                isScrolled ? 'text-[#0A1628]' : 'text-white'
              }`}
            >
              THE PROBLEM
            </button>
            <button 
              onClick={() => scrollToSection('solution')}
              className={`font-semibold text-sm tracking-wider hover:text-[#00A86B] transition-colors ${
                isScrolled ? 'text-[#0A1628]' : 'text-white'
              }`}
            >
              OUR SOLUTION
            </button>
            <Link 
              to="/team"
              className={`font-semibold text-sm tracking-wider hover:text-[#00A86B] transition-colors ${
                isScrolled ? 'text-[#0A1628]' : 'text-white'
              }`}
            >
              OUR TEAM
            </Link>
            <button 
              onClick={() => scrollToSection('faq')}
              className={`font-semibold text-sm tracking-wider hover:text-[#00A86B] transition-colors ${
                isScrolled ? 'text-[#0A1628]' : 'text-white'
              }`}
            >
              FAQ
            </button>
            <Button 
              onClick={() => scrollToSection('cta')}
              className="bg-[#00A86B] hover:bg-[#008f5b] text-white font-bold px-6 py-2 rounded-full flex items-center gap-2"
            >
              <Phone className="w-4 h-4" />
              GET FUNDED
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 ${isScrolled ? 'text-[#0A1628]' : 'text-white'}`}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white rounded-lg shadow-lg p-4 mt-2">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('problem')}
                className="font-semibold text-sm tracking-wider text-[#0A1628] hover:text-[#00A86B] text-left"
              >
                THE PROBLEM
              </button>
              <button 
                onClick={() => scrollToSection('solution')}
                className="font-semibold text-sm tracking-wider text-[#0A1628] hover:text-[#00A86B] text-left"
              >
                OUR SOLUTION
              </button>
              <Link 
                to="/team"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-semibold text-sm tracking-wider text-[#0A1628] hover:text-[#00A86B] text-left"
              >
                OUR TEAM
              </Link>
              <button 
                onClick={() => scrollToSection('faq')}
                className="font-semibold text-sm tracking-wider text-[#0A1628] hover:text-[#00A86B] text-left"
              >
                FAQ
              </button>
              <Button 
                onClick={() => scrollToSection('cta')}
                className="bg-[#00A86B] hover:bg-[#008f5b] text-white font-bold px-6 py-2 rounded-full flex items-center justify-center gap-2 w-full"
              >
                <Phone className="w-4 h-4" />
                GET FUNDED
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
